import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@challenger6/vm-pattern-library/button';
import { ButtonType } from '@challenger6/vm-pattern-library/button';

/**
 * @extended ButtonComponent
 */
@Component({
  selector: 'vm-button',
  templateUrl: '../../../../../vm-global/src/lib/button/button.component.html',
  styleUrls: ['../../../../../vm-global/src/lib/button/button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CareButtonComponent extends ButtonComponent implements OnInit {
  clicked = false;

  onButtonClick(e: MouseEvent) {
    if (
      this.clicked === false &&
      (this.type === ButtonType.BUTTON || this.type === ButtonType.SUBMIT || this.type === ButtonType.ROUTER_LINK)
    ) {
      this.clicked = true;
      this.disabled = true;
    }
    this.buttonClick.emit(e);
  }
}
